import { CurrencyFormatter } from 'helpers/formatters'

export const currencyFormatter = new CurrencyFormatter()

/** Reflow tolerance — over-/under-allocation flagged only past this threshold. */
export const EPSILON = 0.005

/**
 * Centered modal width — the adjust view is a two-column layout (transaction
 * card + section accordion), so it needs more room than the old 900px dialog.
 */
export const ADJUST_MODAL_WIDTH = 1160

export const SOURCE_LABEL: Record<string, string> = {
  marqeta: 'Marqeta',
  i_stream: 'iStream',
  check: 'Check',
  group_ach: 'Group ACH',
  ee_paid: 'EE Paid',
  wex: 'WEX',
}

/**
 * Transaction rails that were added manually and can therefore be deleted from
 * the modal (EE Paid, plus Check / Group ACH refunds). Rail-sourced ingested
 * payments (iStream / Marqeta / WEX) are never deletable.
 */
export const SOURCE_ABLE_TO_DELETE: readonly string[] = [
  'ee_paid',
  'check',
  'group_ach',
]

/**
 * Transaction rails that can be RETURNED (the Return section / row button).
 * iStream only — EPS rejects every other source.
 */
export const SOURCE_ABLE_TO_RETURN: readonly string[] = ['i_stream']

export const isReturnableSource = (
  source: string | null | undefined
): boolean => SOURCE_ABLE_TO_RETURN.includes(source ?? '')

/** Mirrors the EPS returnTransactionRequestSchema `note` cap. */
export const RETURN_NOTE_MAX_LENGTH = 500
